module.exports = __webpack_public_path__ + "img/ybzdywjg_charact_6.9f02b044.svg";